<div class="c-header__toolbar">
  <div class="c-header__nav">
    @if (isMobile) {
      <button class="c-header__toggle" (click)="changeSidebarStatus()">
        <span class="material-symbols-rounded c-header__icon">menu</span>
      </button>
    }

    <div class="c-header__hide-on-mobile">
      <div class="c-header__welcome">
        ¡Te damos la bienvenida,
        {{ primeraLetra(credentials()?.nombre) }}!
      </div>
      <div class="fechaFormato">
        {{ obtenerFechaFormateada() || "-" }}
      </div>
    </div>
  </div>

  <div class="c-header__dropdown" ngbDropdown placement="bottom-right">
    <!-- <button
          routerLink="/notificacion"
          class="c-header__notifications-btn"
          [ngbTooltip]="
            usuario()?.cantidadNotificaciones !== 0
              ? 'Tienes ' + usuario()?.cantidadNotificaciones + ' notificaciones nuevas'
              : 'Sin notificaciones'
          "> -->
    <!-- <button routerLink="/notificacion" class="c-header__notifications-btn">
      <span class="material-symbols-rounded">notifications_unread</span>
    </button> -->

    <div
      class="c-header__dropdown-container"
      id="dropdowAnUserInfo"
      ngbDropdownToggle
    >
      <img
        class="img-fluid c-header__avatar"
        src="assets/images/user-circle.png"
        alt="User Circle"
      />

      <div class="c-header__content">
        <div class="c-header__info">
          <span>{{ credentials()?.nombre | titlecase }}</span>
          <span>{{ credentials()?.rol || "-" }}</span>
        </div>
      </div>

      <span class="material-symbols-rounded">keyboard_arrow_down</span>
    </div>
    <div
      class="c-header__dropdown-container-menu"
      ngbDropdownMenu
      aria-labelledby="dropdownUserInfo"
    >
      <!-- <button ngbDropdownItem routerLink="/perfil">
        <span class="material-symbols-rounded">account_circle</span>
        Mi perfil
      </button> -->
      <!-- @if (credentials()?.rolCodigo === "ROL_ADMIN") { -->
      <!-- <button ngbDropdownItem routerLink="/perfil">
          <span class="material-symbols-rounded">account_circle</span>
          Mi perfil
        </button> -->
      <button ngbDropdownItem routerLink="/actualizar-clave">
        <span class="material-symbols-rounded">lock</span>
        Cambiar contraseña
      </button>

      <button ngbDropdownItem (click)="logout()">
        <span class="material-symbols-rounded">logout</span>
        Cerrar sesión
      </button>
    </div>
  </div>
</div>
